// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
export var honeyPotDataAttribute = 'data-pdnd-honey-pot';